import React from 'react';

export function HeroBanner({ title, subtitle, backgroundImageUrl, children }) {
  return (
    <section
      className="w-full py-12 md:py-20 flex items-center justify-center relative overflow-hidden animate-fadeIn"
      style={{
        minHeight: '400px', // Altura mínima por defecto
        position: 'relative',
      }}
    >
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: `url(${backgroundImageUrl || '/images/banner_default.jpg'})`, // Imagen por defecto
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          filter: 'brightness(0.9)', // Brillo por defecto
        }}
      />
      <div className="absolute inset-0 z-10 bg-gradient-to-b from-black/50 to-transparent" />
      <div className="container mx-auto px-6 md:px-8 py-12 relative z-20">
        {title && (
          <h1 className="text-4xl font-bold tracking-tight text-white sm:text-5xl md:text-6xl mb-6 drop-shadow-xl animate-fadeIn text-center">
            {title}
          </h1>
        )}
        {subtitle && (
          <p className="mx-auto max-w-[800px] text-white text-lg md:text-xl mb-8 drop-shadow-xl animate-fadeIn delay-200 text-center">
            {subtitle}
          </p>
        )}
        {children && (
          <div className="flex flex-col sm:flex-row sm:justify-center space-y-4 sm:space-y-0 sm:space-x-4 mt-6 animate-fadeIn delay-300">
            {children}
          </div>
        )}
      </div>
    </section>
  );
}
